<template>
  <div class="small" v-if="size === 'small'">
    <img class="small" src="/assets/images/circle.gif">
  </div>
  <div class="big" v-else>
    <img class="big" src="/assets/images/circle.gif">
  </div>
</template>

<script>
export default {
  name: "loader",
  props: ['size']
}
</script>

<style scoped>
div.small{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(255,255,255,0.8);
}
img.small{
  position: absolute;
  top: 50%;
  left: 50%;
  height: auto !important;
  transform: translate(-50%, -50%);
  opacity: 0.5;
  max-width: 30px;
}

div.big{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
img.big{
  max-width: 200px;
}
</style>